<template>
  <div class="flex items-center">
    <div class="h-[17px] flex items-center">
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
      <div class="g-item"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$count: 10;
$speed: 1s;

.g-item {
  @apply bg-[#4673EE];
  background: linear-gradient(180deg, #ff7bf8 0%, #0059ff 100%);
  width: 2px;
  border-radius: 1px;
  margin: 0 0.5px;
  --f: #{calc($speed / -3)};
  animation: heightChange $speed infinite ease-in-out alternate;
}

@for $i from 0 to $count {
  .g-item:nth-child(#{$i + 1}) {
    animation-delay: calc(var(--f) * #{$i});
  }
}

@keyframes heightChange {
  from {
    height: 4px;
  }

  to {
    height: 16px;
  }
}
</style>
